module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('strong', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/acknowledgments#ack"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")]), _vm._v(": W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERSON")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEDS TO")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOW")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch1#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("1")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATIENT")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELF")]), _vm._v("-D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETERMINATION")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CT")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EANS TO")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REATMENT")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENEFICIAL AND")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENEFICIAL")]), _vm._v("?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THICAL")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINCIPLES")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FFECT")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EALTH")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECISIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALUE OF")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALUES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DVANCE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRECTIVES")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORK")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALUES")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTORY")]), _vm._v(": D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFINING")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EALTH")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARE")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALUES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU")]), _vm._v(", Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMILY, AND")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EALTH")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECISIONS")]), _vm._v(": C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOOSING A")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROXY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGNING")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DVANCE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRECTIVES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/appendix#app",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Appendix")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/appendix#app1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Links to Advance Directive Forms by State")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/appendix#app2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Useful Links")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/appendix#app3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Advance Directives for Future Medical Treatment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/appendix#app4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Values History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/appendix#app5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advance Directive in Brief Card")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0